module.exports = __webpack_public_path__ + "img/leveler-6-on.48c47df5.png";